import React from "react";
import { Box, Typography } from "@mui/material";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import { styled } from "@mui/material/styles";

const AddressInformation = ({ data }) => {
  const isPickup = data?.delivery_mode === "Pick Up";

  const labelStyle = {
    color: "var(--neutral-800)",
    textAlign: "left",
    lineHeight: "150%",
    fontSize: "14px",
    fontWeight: 500,
  };
  const valueStyle = {
    fontSize: "14px",
    color: "var(--neutral-black)",
    fontWeight: 600,
    textAlign: "left",
  };
  return (
    <Box sx={{ mt: 2 }}>
      <SectionTitle>
        {isPickup ? "Pickup Details" : "Delivery Details"}
      </SectionTitle>

      <InfoCard>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <Box>
            <Typography variant="body2" sx={labelStyle}>
              Name
            </Typography>
            <Typography variant="body1" sx={valueStyle}>
              {data?.billing_name}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={labelStyle}>
              Mobile
            </Typography>
            <Typography variant="body1" sx={valueStyle}>
              {data?.billing_mobile_number}
            </Typography>
          </Box>
        </Box>

        {isPickup ? (
          <Box>
            <Typography variant="body2" sx={labelStyle}>
              Pickup point
            </Typography>
            <InlineInfo>
              <StorefrontOutlinedIcon sx={{ fontSize: 18, color: "#A86E18", mt: 0.2 }} />
              <Typography variant="body1" whiteSpace="pre-line" sx={valueStyle}>
                {`Utsav Pack\n${data?.shops?.shop_name},\n${data?.shops?.address} - ${data?.shops?.pincode},\n${data?.region?.city?.name}`}
              </Typography>
            </InlineInfo>
            <Typography
              variant="body2"
              fontWeight={500}
              color="text.secondary"
              sx={{ mt: 1, ...labelStyle }}
            >
              Pickup contact
            </Typography>
            <Typography variant="body1" sx={valueStyle}>
              {data?.shops?.mobile_no}
            </Typography>
          </Box>
        ) : (
          <Box>
            <Typography variant="body2" sx={labelStyle}>
              Delivery destination
            </Typography>
            <InlineInfo>
              <PlaceOutlinedIcon sx={{ fontSize: 18, color: "#A86E18", mt: 0.2 }} />
              <Typography variant="body1" whiteSpace="pre-line" sx={valueStyle}>
                {`${data?.ordered_address?.full_address},\n${data?.ordered_address?.address_city_district} - ${data?.ordered_address?.address_pincode},\n${data?.ordered_address?.address_state}`}
              </Typography>
            </InlineInfo>
          </Box>
        )}
      </InfoCard>
    </Box>
  );
};

const SectionTitle = styled(Typography)(() => ({
  fontSize: "18px",
  fontWeight: 700,
  color: "var(--neutral-black)",
  marginBottom: "12px",
  textAlign: "left",
}));

const InfoCard = styled(Box)(() => ({
  border: "1px solid rgba(183, 124, 10, 0.22)",
  borderRadius: "16px",
  padding: "16px 18px",
  background: "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(255,250,242,0.96) 100%)",
  boxShadow: "0 10px 24px rgba(173, 132, 61, 0.08)",
}));

const InlineInfo = styled(Box)(() => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "10px",
}));

export default AddressInformation;
